import {
  safeLocalGet,
  safeLocalSet,
  safeSessionGet,
  safeSessionSet,
} from './safeStorage';

export const ANALYTICS_CONSENT_KEY = 'resumeready_optional_analytics_v1';
const ATTRIBUTION_KEY = 'rr_marketing_attribution_v1';
const REFERRAL_KEY = 'rr_referral_code_v1';
const FIRST_VALUE_KEY = 'rr_first_value_tracked_v1';
const MARKETING_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'fbclid',
  'gclid',
];

const clean = (value, max = 200) => String(value || '').trim().slice(0, max);

export function createEventId(prefix = 'event') {
  try {
    if (window.crypto?.randomUUID) return `${prefix}-${window.crypto.randomUUID()}`;
    if (window.crypto?.getRandomValues) {
      const bytes = new Uint32Array(4);
      window.crypto.getRandomValues(bytes);
      return `${prefix}-${Array.from(bytes, (part) => part.toString(16)).join('-')}`;
    }
  } catch {
    // Safari may deny crypto in strict privacy contexts.
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function hasAnalyticsConsent() {
  return safeLocalGet(ANALYTICS_CONSENT_KEY) === 'granted';
}

// Referral codes are functional application state. Marketing click identifiers are
// stored separately and only after optional analytics consent.
export function captureAttribution(search = window.location.search) {
  const params = new URLSearchParams(search || '');
  const referral = clean(params.get('ref'), 100);
  if (referral) safeSessionSet(REFERRAL_KEY, referral);

  if (!hasAnalyticsConsent()) return {};
  const current = getAttribution();
  MARKETING_KEYS.forEach((key) => {
    const value = clean(params.get(key));
    if (value) current[key] = value;
  });
  safeSessionSet(ATTRIBUTION_KEY, JSON.stringify(current));
  return current;
}

export function getAttribution() {
  try {
    const parsed = JSON.parse(safeSessionGet(ATTRIBUTION_KEY, '{}'));
    return MARKETING_KEYS.reduce((result, key) => {
      const value = clean(parsed?.[key]);
      if (value) result[key] = value;
      return result;
    }, {});
  } catch {
    return {};
  }
}

export function getReferralCode() {
  return clean(safeSessionGet(REFERRAL_KEY), 100) || null;
}

export function markFirstValueTracked() {
  if (safeLocalGet(FIRST_VALUE_KEY) === '1') return false;
  safeLocalSet(FIRST_VALUE_KEY, '1');
  return true;
}
